import { open_modal } from "packs/custom_js/tepdoc.js"
import { display_error } from "packs/custom_js/runtime.js"
import { display_notice } from "packs/custom_js/runtime.js"
Window.totem_global = {
	modal_sleep: false,
  open_modal: open_modal,
  display_error: display_error,
  display_notice: display_notice
}